import { createFileRoute, redirect } from '@tanstack/react-router';

import { BUILDER_STEPS } from 'shared/consts';
import { routes } from 'shared/routes';

export const Route = createFileRoute('/_authenticated/locations/$id/cb/campaign/$campaignId/edit/_edit/')({
  beforeLoad: ({ params }) => {
    throw redirect(routes.cbCampaignEditStep(params.id, params.campaignId, BUILDER_STEPS.SCAN));
  }
});
